import { useId } from 'react';
import { Button, Modal } from '@shared/components';
import { DOCUMENT_TYPE_LABELS } from '@/features/document-templates/utils/documentTypeLabels';
import type { GeneratedDocument } from '../../types/agreementDocuments.types';
import { DocumentProvenance } from './DocumentProvenance';

interface Props {
    document: GeneratedDocument | null;
    now: number;
    canRead: boolean;
    onView?: (document: GeneratedDocument) => void;
    onDownload?: (document: GeneratedDocument) => void;
    onClose: () => void;
}

export function DocumentDetailsModal({ document, now, canRead, onView, onDownload, onClose }: Props) {
    const headingId = useId();

    return (
        <Modal isOpen={document !== null} onClose={onClose} ariaLabelledBy={headingId} className="w-full max-w-xl p-6">
            {document && (
                <div className="space-y-4">
                    <h2 id={headingId} className="text-lg font-semibold">{DOCUMENT_TYPE_LABELS[document.documentType]} details</h2>
                    <DocumentProvenance document={document} now={now} />
                    <div className="flex flex-wrap justify-end gap-2">
                        {canRead && document.status === 'generated' && onView && (
                            <Button type="button" size="sm" variant="primary" appearance="outline" onClick={() => onView(document)}>
                                View
                            </Button>
                        )}
                        {canRead && document.status === 'generated' && onDownload && (
                            <Button type="button" size="sm" variant="primary" appearance="outline" onClick={() => onDownload(document)}>
                                Download
                            </Button>
                        )}
                        <Button type="button" size="sm" variant="neutral" appearance="ghost" onClick={onClose}>
                            Close
                        </Button>
                    </div>
                </div>
            )}
        </Modal>
    );
}
